import { Outlet } from 'react-router-dom';

import { AccountLayout } from '@/features/account';
import { ACCOUNT_PATH } from '@/features/account/constants';
import { GuardAuthenticated } from '@/features/auth';
import { UserType } from '@/services/api';

export const AccountAuthenticatedLayout: React.FC = () => {
  return (
    <GuardAuthenticated
      authorizations={[UserType.CompanyAdmin, UserType.User]}
      loginPath={`${ACCOUNT_PATH}/login`}
    >
      <AccountLayout>
        <Outlet />
      </AccountLayout>
    </GuardAuthenticated>
  );
};
